// Main entry — the production View. (No Container: ProgramNameField is a
// pure controlled View.) Sim wrappers live under ./sim and are never
// imported here.
export { ProgramNameField } from "./ProgramNameField";
export type { ProgramNameFieldProps } from "./ProgramNameField";
